import { type FC, useContext } from "react";
import { useShopfrontDispatch } from "../../../../../_Bootstrap/hooks";
import { showDialog } from "../../../../../Actions/Dialogs/DialogActions";
import FontAwesomeLight from "../../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../../../../Buttons/Button";
import HTMLEditorDialog from "../../../../Dialogs/HTMLEditorDialog";
import { ZendeskLink } from "../../../../Misc/ZendeskLink";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../DragDropTypes";

export const TextComponentSettings: FC<DragDropSettingsProps> = ({ id, value }) => {
    const dispatch = useShopfrontDispatch();

    const { manager } = useContext(DragDropEditorContext);

    return (
        <>
            <ZendeskLink
                className="settings-help"
                title="Adding Dynamic Fields"
                id="360021173732"
            >
                <FontAwesomeLight icon="question-circle" />
            </ZendeskLink>
            <Button
                type="button"
                classes={[ "button-add", "text-edit-button" ]}
                onClick={(e): void => {
                    e.stopPropagation();

                    dispatch(showDialog(
                        "Edit Text",
                        <HTMLEditorDialog
                            html={typeof value === "string" ? value : ""}
                            onSubmit={(value: string) => {
                                manager.updateComponent(id, value);
                            }}
                            autoFocus
                        />,
                        "information",
                        false,
                        false,
                        true,
                        false
                    ));
                }}
            >
                <FontAwesomeLight icon="edit" />Edit Text
            </Button>
        </>
    );
};
